import React from 'react';
import logo from "../../../../common/assets/logo.png";
import styles from './FooterLogo.module.scss';

const FooterLogo = () => {
  return (
    <img
      src={logo}
      alt="Azmai logo"
      className={styles.footerLogo}
    />
  );
};

export default FooterLogo;
